



































































































import Vue from "vue";
import { METHODS } from "http";
import VueRouter from "vue-router";

export default Vue.extend({
  name: "App",

  data: () => ({
    dialog: false,
    drawer: false,
    fullScreenIcon: "mdi-fullscreen",
    items: [
      {
        icon: "mdi-cards-playing-outline",
        text: "1-100",
        link: "/cards/one-to-hundred"
      },
      {
        icon: "mdi-cards-outline",
        text: "1-13",
        link: "/cards/one-to-thirteen"
      },
      {
        icon: "mdi-tshirt-crew",
        text: "S-XXL",
        link: "/cards/s-to-xxl"
      }
    ]
  }),
  methods: {
    toggleFullscreen() {
      if (document.fullscreen) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
    },
    updateFullscreenIcon() {
      if (document.fullscreen) {
        this.fullScreenIcon = "mdi-fullscreen-exit";
      } else {
        this.fullScreenIcon = "mdi-fullscreen";
      }
    }
  },
  created: function() {
    document.addEventListener("fullscreenchange", this.updateFullscreenIcon);
  },
  destroyed: function() {
    document.removeEventListener("fullscreenchange", this.updateFullscreenIcon);
  }
});
